import type { StoreCustomer, StoreProductCategory } from "@medusajs/types";
import { clx } from "@medusajs/ui";
import PlaceholderImage from "@modules/common/icons/placeholder-image";
import HighLightsNav from "@modules/home/components/hightlights";
import DrawerCustom from "@modules/layout/components/drawer-custom";
import Accordion from "@modules/products/components/product-tabs/accordion";
import Image from "next/image";
import Link from "next/link";
import AccountButton from "./account-button";
import { buildCategoryTree } from "./category-dropdown";

type Props = {
  customer: StoreCustomer | null;
  state: boolean;
  onClose: () => void;
  productCategories: StoreProductCategory[];
};

function MenuMobile({ customer, state, onClose, productCategories }: Props) {
  const categories = buildCategoryTree(productCategories);

  return (
    <DrawerCustom
      isOpen={state}
      onClose={onClose}
      header={<AccountButton customer={customer} onClose={onClose} isMobile />}
      content={
        <div>
          <Accordion type="multiple" defaultValue={["Danh mục sản phẩm"]}>
            <Accordion.Item title={"Danh mục sản phẩm"} headingSize="medium" value={"Danh mục sản phẩm"}>
              {categories.map((category) => (
                <div onClick={() => onClose()} key={category.id}>
                  <Link href={`/categories/${category.handle}`} className="group w-[300px] ">
                    <div
                      className={clx(
                        "text-[12px] py-2 px-2 hover:bg-gray-200 rounded-md cursor-pointer font-semibold transition-all duration-200 hover:text-primary-500 flex gap-2 items-center"
                      )}
                    >
                      <div className="rounded-md">
                        {typeof category?.metadata?.thumbnail === "string" ? (
                          <Image
                            src={category.metadata.thumbnail}
                            alt="Product Thumbnail"
                            width={28}
                            height={28}
                            unoptimized
                          />
                        ) : (
                          <PlaceholderImage size={28} color="gray" />
                        )}
                      </div>
                      {category.name}
                    </div>
                  </Link>
                </div>
              ))}
            </Accordion.Item>
          </Accordion>
        </div>
      }
      footer={
        <div className="bg-[#FF0066] text-white text-[14px] p-2">
          <HighLightsNav />
        </div>
      }
    />
  );
}

export default MenuMobile;
